import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    error: {
        id: 'auth.action.logout.error',
        defaultMessage: 'Something went wrong',
    },
    content: {
        id: 'auth.action.logout.error_content',
        defaultMessage: "Can't logout properly",
    },
})
